import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedin,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div className="footer-col footer-brand">
          <a href="#top" className="nav-logo">
            <img src={process.env.PUBLIC_URL + "/logo.png"} alt="Logo" />
            Ajovwokeoghene
          </a>
          <p>
            Full-Stack & Mobile Developer building production apps with real
            users, based in Aberdeen, UK.
          </p>
        </div>

        <div className="footer-col">
          <h5>Quick Links</h5>
          <ul>
            <li>
              <a href="#skills">Skills</a>
            </li>
            <li>
              <a href="#projects">Projects</a>
            </li>
            <li>
              <a href="#about">About</a>
            </li>
            <li>
              <a href="#contact">Contact</a>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h5>Connect</h5>
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/in/ajovwokeogheneanuta"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="LinkedIn"
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a
              href="https://github.com/JaySmart001"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="GitHub"
            >
              <FontAwesomeIcon icon={faGithub} />
            </a>
            <a
              href="https://wa.me/message/IWKFOX6HVTO7C1"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="WhatsApp"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Ajovwokeoghene Anuta</span>
        <span>Aberdeen, UK</span>
      </div>
    </footer>
  );
};

export default Footer;
